import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'start',
      redirect: '/steps/0'
    },{
      path: '/steps/:id',
      name: 'steps',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: function () {
        return import(/* webpackChunkName: "steps" */ './views/Steps.vue')
      },
      props: true
    },{
      path: '/credits/:id?',
      name: 'credits',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: function () {
        return import(/* webpackChunkName: "credits" */ './views/Credits.vue')
      },
      props: true
    }
  ]
})
